import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { IntegrationConnectionDto } from "../dto/integrationConnection/integration-connection.dto";

const c = initContract();

export const gustoIntegrationContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: z.object({
                code: z.string(),
                defaultEntityId: z.number().optional(),
                /**
                 * Omitted when an accounting firm connects from the
                 * organization view: the connection is created without a
                 * client and its accounts are assigned afterwards.
                 */
                workspaceId: z.string().uuid().optional(),
            }),
            responses: {
                200: c.type<IntegrationConnectionDto>(),
                403: z.object({ message: z.string() }),
                409: z.object({ message: z.string() }),
            },
        },
        syncConnection: {
            method: "POST",
            path: "/sync/:connectionId",
            pathParams: z.object({
                connectionId: z.string().uuid(),
            }),
            query: z.object({
                workspaceId: z.string().uuid(),
            }),
            body: c.noBody(),
            responses: {
                200: c.type<IntegrationConnectionDto>(),
                400: z.object({ message: z.string() }),
            },
        },
    },
    { pathPrefix: "/gusto" },
);
